import client from '../client'
import qs from 'qs'

export const signupValidateCheck = async ({ name, value }) => {
  const queryString = qs.stringify({ [name]: value })
  console.log(queryString)
  const response = await client.get(`/auth/signup/validate?${queryString}`)

  return response.data
}
